import { render, staticRenderFns } from "./ShowRank.vue?vue&type=template&id=188059d2&scoped=true&"
import script from "./ShowRank.vue?vue&type=script&lang=ts&"
export * from "./ShowRank.vue?vue&type=script&lang=ts&"
import style0 from "./ShowRank.vue?vue&type=style&index=0&id=188059d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188059d2",
  null
  
)

export default component.exports